import { render, staticRenderFns } from "./MaterialJournals.vue?vue&type=template&id=37aa3f15"
import script from "./MaterialJournals.vue?vue&type=script&lang=js"
export * from "./MaterialJournals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports